<div class="lit-root" (pointerdown)="$event.stopPropagation()">
  <div class="label">literal ({{ data.literalKind }})</div>
  @if (data.literalKind === 'null') {
    <div class="readonly">null</div>
  } @else {
    <input
      class="text"
      [value]="displayValue()"
      (input)="changeText(($any($event.target)).value)"
      placeholder="value"
    />
    @if (data.literalKind === 'string[]') {
      <div class="hint">カンマ区切りで入力（例: 40,41,42）</div>
    }
  }
</div>

